// import { useSelector } from 'react-redux'
import OrdersCart from '@/entities/cart-page/OrdersCart'
import StatisticCart from '@/entities/cart-page/StatisticCart'
import { ProductToPresent } from '../../ProductToPresent/ui/ProductToPresent'

export const CartOrders = ({data, refetch, cert, userInfo}) => {
    return (
        data && <>
            <div className={'CartOrders'}>
                <OrdersCart
                    codeAplied={data?.voucher}
                    refetch={refetch}
                    data={data}
                    userInfo={userInfo}
                />
                <StatisticCart totals={data.totals} userInfo={userInfo} />
            </div>
            {!cert && <ProductToPresent refetchCart={refetch} />}
        </>
    )
}
